<script>
import { menuItems } from "./horizontal-menu";
import { anonymousMenuItems } from "./anonymous-Menu-Items";


 

/**
 * Nav-bar Component
 */
export default {
  computed: {
   
    

  },
  data() {
    return {
      
      text: null,
      flag: null,
      value: null,

      keyword:"",
      supplierFullName:'',

      interval: null,

     

      selectedUserList:[],
      showUsersModal:false,

      showDraftOrder: false,

      menuItems: menuItems,
      anonymousMenuItems: anonymousMenuItems,
      countLastRequestQuote: null


    };
  },

  created() {
      
    },
    beforeDestroy () {
      clearInterval(this.interval);
    },

  mounted() {
    




  },
  methods: {
    getCountLastRequestQuote() {


      },

    
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    

    toNotificationIcon(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "fas fa-dolly";
        case 1: return "fas fa-check-double";
        case 2: return "fas fa-truck-loading";
        case 3: return "fas fa-exclamation-triangle";
        case 4 : return "fas fa-file-invoice-dollar";
        default : return "fas fa-dolly";
      }
    },

    toNotificationColor(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "bg-danger";
        case 1: return "bg-info";
        case 2: return "bg-success";
        case 3: return "bg-secondary";
        case 4: return "bg-primary";
        default : return "bg-secondary";
      }
    },

    toPath(notificationType){
      if (notificationType == null) {
        return;
      }
      if(notificationType==0 || notificationType==1 || notificationType==2 || notificationType==3){
        return '/orders/order'
      }
    },

    toQuery(notif){
      if (notif == null) {
        return;
      }
      if(notif.type==0 || notif.type==1 || notif.type==2 || notif.type==3){
        return notif.orderId
      }

      if(notif.type==4){
        return null
      }
    },

    connect() {
      if(!this.userFullName) {
        this.$router.push({ name: "login" });
      }
    },

    onDraftModalClose() {
      this.$root.$emit('order-cart-modal-closed', true)
    },

    scrollToElement(link) {
      if (link && link.startsWith("#")) {
        const id = link.slice(1).replace(/-/g, "");
        const elmnt = document.getElementById(id);
        if (elmnt) {
          elmnt.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
         this.$router.push({ path: link });
      }
    },

  },

  watch :{

    '$route.query.filter': {
        handler: function(filter) {
          this.keyword = filter;
        },
        deep: true,
        immediate: true
    },

    role: function() {
  
    },


    

    
  }

  


};
</script>

<style>
  /* .navbar-header .dropdown.show .header-item {
    background-color: #5cb45b;
} */

    .navbar-header .mobile-user-button .dropdown .dropdown-menu {
        left: 10px !important;
        right: 10px !important;
        min-width:300px;
    }

    @media all and (max-width: 1024px) and (min-width: 1024px) {
    #logo {
        padding-left: 20px;
    } 

    }


  
    .menu {
      overflow-x: scroll;
      overflow-y: hidden; 
      white-space: nowrap;
      width: 100%;
      height: 100%; 
      -ms-overflow-style: none; 
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
    }

    .menu::-webkit-scrollbar {
      display: none; /* hide scrollbar on Chrome and Safari */
    }

    .menu:active {
      cursor: grab;
      cursor: -webkit-grab;
    }

    .menu:active::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }

    .menu:active::-webkit-scrollbar-track {
      background-color: #f1f1f1;
    }

    .menu ul {
      display: flex; /* use flexbox to make menu items expand to fill available space */
      align-items: stretch; /* stretch menu items to the full height of the menu */
    }

    .menu li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /*border-bottom: 3px solid white;*/
  /*border-top: 3px solid white;*/
  cursor: pointer;
  position: relative;
}

/* .menu li a:hover {
  color: #00acc8 !important;
} */

.menu li.active a,

.menu li.active,
.menu li:hover {
  /*border-bottom: 3px solid #137437;*/
  color: #137437 !important;
}

.menu_title {
  color: white !important;
  text-shadow: 
    2px 2px 4px rgba(29, 185, 100, 0.5), 
    -2px -2px 6px rgba(0, 255, 255, 0.8);
}


.menu_title:hover {
  /*background-color: #ddd;*/
  color: #cfcece !important;
}


.menu li a {
  display: flex; /* enable flexbox layout */
  align-items: center; /* center link content vertically */
  justify-content: center; /* center link content horizontally */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-decoration: none;

  color: #333;
  text-decoration: none;
      font-size: 14px;
      font-weight: bold;
}

menu ul {
      display: inline-block;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

  

</style>

<template>  
<div  class="d-none d-lg-block" >
 
  <!-- style="border-bottom: 1px solid #f4f4f4;" #61b083ab  #d1e5d57a -->
   <!-- :style=" $route.name != 'default'  ? '':    '  background: linear-gradient(to bottom,  transparent, #ddd, transparent);'"  -->
  <header id="homepage-topbar" >
  <!-- <header id="page-topbar"  > -->


    <!-- LOGO BLOCK & MOBILE MENU BUTTON -->
    <div class="navbar-header"   >


      <div class="row w-100 m-sm-4 m-0 " >

        <div class="col-1 col-md-6 col-lg-2 col-xl-4 col-xxl-6" style="z-index:9999999">
            <div class="d-flex mobile-user-button">

              <!-- MAIN LOGO -->
              <div class="my-auto" >
                <router-link to="/" class="logo logo-light mt-3 " id="logo" >
                  <span class="logo-sm">
                    <img class="ml-2" src="@/assets/images/logo.png"   alt height="15"  />
                  </span>
                  <span class="logo-lg">
                    <img src="@/assets/images/logo.png" alt height="70" />
                  </span>
                </router-link>
              </div>
            </div>
            
        </div>

        <div class="col-0 col-md-0 col-lg-8 col-xl-8 col-xxl-6 d-none d-lg-block my-auto" style="margin-top: 0px !important;margin-bottom: 0px !important;">

              <div class="my-auto" style="height:100%;" >
                  
              
                <div class="menu">
               
                  <ul style="margin: 0; height: 100%;">
                    <template v-for="(item, index) in anonymousMenuItems">
                      <li
                        :class="$route.name !== 'default' && $route.path === item.link ? 'active' : ''"  :key="index"
                      >

                      <!-- onMenuClick($event) -->

                      <!-- role="menuitem"
                          aria-current="$route.path === item.link ? 'page' : null" -->
                        <a href="javascript:void(0)"
                          class="text-secondary text-uppercase" :class="item.color ? item.color : 'text-secondary'"
                         
                          role="button"
                          @click="scrollToElement(item.link)"
                        >
                         {{ $t(item.label) }}
                        </a>
                      </li>
                    </template>

                  </ul>


                </div>




                

              </div>

        </div>

       

      </div>

    </div>

  </header>

</div>

</template>


<style scoped>
.menu-mobile {
  width: 100%;
  background-color: #fff; 
  position: fixed;
  top: 0;
  z-index: 1000; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: block;
    flex-direction: column; 
    justify-content: space-between;
    height: 100%;

    li {
      padding: 15px 20px;
      text-align: left;
      font-size: 1rem;
      transition: background-color 0.3s ease, color 0.3s ease;

      &.active {
        background-color: #f0f0f0;
        font-weight: bold;
        border-left: 4px solid #137437;
      }

      &:hover {
        background-color: #e9ecef;
      }

      .text-dark {
        color: #333;
        text-decoration: none;
      }

      .text-uppercase {
        text-transform: uppercase; 
      }
    }
  }

  a {
    color: inherit; 
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: 768px) {
    ul {
      flex-direction: row; 
    }

    li {
      padding: 10px 15px; 
    }
  }
}

.circular-badge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
}

#homepage-topbar {
    position: relative;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1002;
    background:#000 !important;
}


</style>